import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { STATUS } from '../../../../redux/constants';
import { ScoreCard } from '../../../HomeContainer/components/Home/IOCDetail';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function IOC(props) {
  const { status, scoreDetails: scoreData } = props;

  const q = useQuery();
  const [query] = useState(q);

  useEffect(() => {
    document.title = 'Score Card - Silent Push';
  }, []);

  useEffect(() => {
    props.loadScoreDetails(query.get('id'), query.get('feed'));
    props.loadNewScoreDetails(query.get('feed'));
  }, [query]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="container">
      {/*<div className="threatRankingBackButton" onClick={handleBackClick}>
        <img src={back_arrow_icon} alt="back_arrow" />
        <span className="threat_ranking_text">Threat Ranking</span>
      </div>*/}
      {status === STATUS.LOADED && (
        <>
          <div
            style={{
              color: '#b1c4d0',
              background: '#16262B',
              borderRadius: '6px 6px 6px 6px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
            }}
          >
            <ScoreCard
              ioc={scoreData}
              newScoreDetails={props.newScoreDetails}
              exportSingleIOC={props.exportSingleIOC}
              history={props.history}
              openedAsPopup={true}
              // setExpandedRowsKeys={setExpandedRowsKeys}
              toggleFalsePositive={props.toggleFalsePositive}
              toggleTruePositive={props.toggleTruePositive}
            />
          </div>
          {/*renderFeedIndicators()*/}
          {/*renderSecondaryIndicators()*/}
          {/*renderCustomIndicators()*/}
        </>
      )}
    </div>
  );
}

export default IOC;
